var EmailFormEmailInputView, EmailFormTextInputView, GrouponValidate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

GrouponValidate = require('../../../../../groupon/frontend/validate');

EmailFormEmailInputView = (function(superClass) {
  extend(EmailFormEmailInputView, superClass);

  function EmailFormEmailInputView() {
    return EmailFormEmailInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormEmailInputView.prototype.tagName = 'li';

  EmailFormEmailInputView.prototype.events = {
    'keyup .email_input': 'validateEmail'
  };

  EmailFormEmailInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".email_input";
    this.errorElementID = ".validateEmailInput";
    return this.template = {
      email_input_template: true
    };
  };

  EmailFormEmailInputView.prototype.isInputValid = function(hideErrorMsg) {
    var email, isValidEmail, ref, ref1;
    email = (ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    isValidEmail = true;
    this.hideErrorElements();
    if ((email != null) && email !== void 0 && email !== "") {
      isValidEmail = GrouponValidate.email(email);
      $('.email-input').find('.icon-circle-alert').remove();
      $('.email-input').removeClass('error');
      if (isValidEmail) {
        this.$el.find(this.errorElementID).css('display', 'none');
        $('.call-back-email-input').removeClass('call-back-inputs-error-border');
      } else if (!hideErrorMsg) {
        this.$el.find(this.errorElementID).css('display', 'block');
        $('.email-input').append('<span class="icon icon-circle-alert"></span>');
        $('.email-input').addClass('error');
      }
    }
    return isValidEmail;
  };

  EmailFormEmailInputView.prototype.hideErrorElements = function() {
    $('.email-input').find('.icon-circle-alert').remove();
    $('.email-input').removeClass('error');
    this.$el.find(this.errorElementID).css('display', 'none');
    return $('.call-back-email-input').removeClass('call-back-inputs-error-border');
  };

  EmailFormEmailInputView.prototype.validateEmail = function() {
    this.isInputValid(true);
    return this.validateEmailForm();
  };

  EmailFormEmailInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      return data.user_email = this.readInput();
    }
  };

  return EmailFormEmailInputView;

})(EmailFormTextInputView);

module.exports = EmailFormEmailInputView;

//# sourceMappingURL=data:application/json;base64,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
